var EmailFormEmailInputView, EmailFormTextInputView, GrouponValidate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

GrouponValidate = require('../../../../../groupon/frontend/validate');

EmailFormEmailInputView = (function(superClass) {
  extend(EmailFormEmailInputView, superClass);

  function EmailFormEmailInputView() {
    return EmailFormEmailInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormEmailInputView.prototype.tagName = 'li';

  EmailFormEmailInputView.prototype.events = {
    'keyup .email_input': 'validateEmail'
  };

  EmailFormEmailInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".email_input";
    this.errorElementID = ".validateEmailInput";
    return this.template = {
      email_input_template: true
    };
  };

  EmailFormEmailInputView.prototype.isInputValid = function(hideErrorMsg) {
    var email, isValidEmail, ref, ref1;
    email = (ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    isValidEmail = true;
    this.hideErrorElements();
    if ((email != null) && email !== void 0 && email !== "") {
      isValidEmail = GrouponValidate.email(email);
      $('.email-input').find('.icon-circle-alert').remove();
      $('.email-input').removeClass('error');
      if (isValidEmail) {
        this.$el.find(this.errorElementID).css('display', 'none');
        $('.call-back-email-input').removeClass('call-back-inputs-error-border');
      } else if (!hideErrorMsg) {
        this.$el.find(this.errorElementID).css('display', 'block');
        $('.email-input').append('<span class="icon icon-circle-alert"></span>');
        $('.email-input').addClass('error');
      }
    }
    return isValidEmail;
  };

  EmailFormEmailInputView.prototype.hideErrorElements = function() {
    $('.email-input').find('.icon-circle-alert').remove();
    $('.email-input').removeClass('error');
    this.$el.find(this.errorElementID).css('display', 'none');
    return $('.call-back-email-input').removeClass('call-back-inputs-error-border');
  };

  EmailFormEmailInputView.prototype.validateEmail = function() {
    this.isInputValid(true);
    return this.validateEmailForm();
  };

  EmailFormEmailInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      return data.user_email = this.readInput();
    }
  };

  return EmailFormEmailInputView;

})(EmailFormTextInputView);

module.exports = EmailFormEmailInputView;

//# sourceMappingURL=data:application/json;base64,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
